import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeCompanyListItem extends SearchModelBase {
    inactive: boolean|null = null;
    terms: number|null = null;
    toTerms: number|null = null;
    fromTerms: number|null = null;
    creditLimit: number|null = null;
    toCreditLimit: number|null = null;
    fromCreditLimit: number|null = null;
    shortName: string = '';
    phone: string = '';
    fax: string = '';
    contact: string = '';
    creditHold: boolean|null = null;
    salesPerson: string = '';
    accountNo: string = '';
    bondNo: string = '';
    iataNo: string = '';
    companyRefNo: string = '';
    idType: string = '';
    taxId: string = '';
    groupId: string = '';
    fullName: string = '';
    address: string = '';
    city: string = '';
    state: string = '';
    zipCode: string = '';
    country: string = '';
    localName: string = '';
    localAddress: string = '';
    billTo: string = '';
    brokerName: string = '';
    csr: string = '';
    email: string = '';
    createdAt: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    id: number = 0;
    u1ID: string = '';
    u2ID: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex:'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Inactive', width: 60, dataIndex: 'inactive', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 2, text: 'Company Name', width: 200, dataIndex: 'shortName', defaultColumnFocus : true}),
        XCol.Create({ col: 3, text: 'Company Ref. #', width: 120, dataIndex: 'companyRefNo', visible: false}),
        XCol.Create({ col: 4, text: 'Contact', width: 100, dataIndex: 'contact'}),
        XCol.Create({ col: 5, text: 'Email', width: 150, dataIndex: 'email'}),
        XCol.Create({ col: 6, text: 'Phone #', width: 80, dataIndex: 'phone'}),
        XCol.Create({ col: 7, text: 'CR Term', width: 50, dataIndex: 'terms', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 8, text: 'CR Limit', width: 50, dataIndex: 'creditLimit', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 9, text: 'CR Hold', width: 50, dataIndex: 'creditHold', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 10, text: 'Tax ID Type', width: 100, dataIndex: 'idType', type: XCol.XCellType.String }),
        XCol.Create({ col: 11, text: 'Tax ID #', width: 80, dataIndex: 'taxId', type: XCol.XCellType.String }),
        XCol.Create({ col: 12, text: 'Bond #', width: 80, dataIndex: 'bondNo'}),
        XCol.Create({ col: 13, text: 'IATA #', width: 80, dataIndex: 'iataNo'}),
        XCol.Create({ col: 14, text: 'Bank Account #', width: 100, dataIndex: 'accountNo', visible: false}),
        XCol.Create({ col: 15, text: 'Salesperson', width: 80, dataIndex: 'salesPerson'}),
        XCol.Create({ col: 16, text: 'Cust. SVC Rep', width: 80, dataIndex: 'csr', visible: false}),
        XCol.Create({ col: 17, text: 'Broker', width: 80, dataIndex: 'brokerName', visible: false}),
        XCol.Create({ col: 18, text: 'Full Name', width: 200, dataIndex: 'fullName'}),
        XCol.Create({ col: 19, text: 'Fax #', width: 80, dataIndex: 'fax'}),
        XCol.Create({ col: 20, text: 'Address', width: 150, dataIndex: 'address'}),
        XCol.Create({ col: 21, text: 'City', width: 80, dataIndex: 'city'}),
        XCol.Create({ col: 22, text: 'State', width: 80, dataIndex: 'state'}),
        XCol.Create({ col: 23, text: 'Zip', width: 50, dataIndex: 'zipCode'}),
        XCol.Create({ col: 24, text: 'Country', width: 50, dataIndex: 'country'}),
        XCol.Create({ col: 25, text: 'Local Name', width: 100, dataIndex: 'localName', visible: false}),
        XCol.Create({ col: 26, text: 'Local Address', width: 200, dataIndex: 'localAddress', visible: false}),
        XCol.Create({ col: 27, text: 'Group', width: 50, dataIndex: 'groupId'}),
        XCol.Create({ col: 28, text: 'Bill To', width: 80, dataIndex: 'billTo'}),
        XCol.Create({ col: 29, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 30, text: 'Create by', width: 88, dataIndex: 'u1ID'}),
        XCol.Create({ col: 31, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 32, text: 'Update by', width: 88, dataIndex: 'u2ID'}),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeCompanyListItem.prototype.CreatedAt, orderByAscending: false };

    public static formatData(data: CodeCompanyListItem[]) {
        return data.map((d: CodeCompanyListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        terms: {from: 'fromTerms', to: 'toTerms'},
        creditLimit: {from: 'fromCreditLimit', to: 'toCreditLimit'},
        u2Date: { from: 'fromU2Date', to: 'toU2Date'},
    }

}
